import React from 'react'
import WorksList from '../../components/WorkList'
import { Reveal, SplitReveal } from '../../components/motion'
import { clientProjects, ownProjects } from '../../constants/projects'

function Works() {
    return (
        <div className="bg-white">
            <section className="container-site pt-[48px] md:pt-[96px]">
                <h1 className="t-display max-w-[900px]">
                    <SplitReveal text="Projeler" />
                </h1>
                <Reveal delay={0.1} className="mt-8 max-w-[640px]">
                    <p className="t-intro font-normal">
                        Müşteriler için geliştirdiğim ürünler ve kendi uygulamalarım. Her projede yalnızca bugün açılan bağlantılar var.
                    </p>
                </Reveal>
            </section>

            <section className="container-site pt-[80px] md:pt-[120px]" aria-label="Müşteri projeleri">
                <Reveal><p className="t-eyebrow mb-12">Müşteri projeleri</p></Reveal>
                <WorksList items={clientProjects} />
            </section>

            <section className="container-site pb-[120px] pt-[120px] md:pt-[180px]" aria-label="Kendi ürünlerim">
                <Reveal><p className="t-eyebrow mb-12">Kendi ürünlerim</p></Reveal>
                <WorksList items={ownProjects} />
            </section>
        </div>
    )
}

export default Works
